import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import { validRoles } from "./SemanticArticleTypes";

var SemanticArticle = function SemanticArticle(_ref) {
  var children = _ref.children,
      role = _ref.role,
      schema = _ref.schema;
  var getClassName = getClassNameFactory(SemanticArticle.displayName);
  return /*#__PURE__*/React.createElement("article", {
    className: getClassName(),
    role: role
  }, typeof schema === "undefined" ? null : /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schema)), children);
};

SemanticArticle.displayName = "SemanticArticle";
export default SemanticArticle;
export { validRoles };